/* eslint-disable no-restricted-syntax */
import { useState, useEffect } from 'react';
import {
  Form, Button, message,
} from 'antd';
import request from '@api';
import classes from './Tab1.module.css';
import CompanyInfo from './CompanyInfo';
import CompanyAddress from './CompanyAddress';
import BillAddress from './BillAdress';
import AccountContact from './AccountContact';
// import { mockQueryOrgsettings, mockUpdateOrgsettings } from './Mock';
import { FullpageLoading } from '../../components';
import useSettings from '../../hooks/useSettings';

export default function Tab1() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const { settingsInfo = {}, settingsLoading, getSettings } = useSettings();

  const handleSave = async () => {
    // console.log(form.getFieldsValue());
    const values = form.getFieldsValue();
    const billingAddress = {};
    for (const key in values) {
      if (Object.hasOwn(values, key) && key.indexOf('other') > -1) {
        billingAddress[key.split('_')[1]] = values[key];
        delete values[key];
      }
    }
    try {
      const { code } = await request('organization-settings', {
        method: 'POST',
        body: {
          ...values, billingAddress,
        },
      });
      // const { code, data } = mockUpdateOrgsettings;
      if (code === 0) {
        message.success('Your changes have been saved.');
        setDisabled(true);
        getSettings();
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!settingsLoading) {
      const defaultValues = { billType: 1, timeZone: 'America/New_York' };

      const { billingAddress = {} } = settingsInfo;
      if (Object.keys(billingAddress)?.length) {
        defaultValues.billType = 2;
        for (const key in billingAddress) {
          if (Object.hasOwn(billingAddress, key)) {
            defaultValues[`other_${key}`] = billingAddress[key];
          }
        }
      }
      form.setFieldsValue({ ...settingsInfo, ...defaultValues });
    }
  }, [settingsInfo]);

  if (settingsLoading) return <FullpageLoading mask />;

  return (

    <Form
      name="org-settings"
      layout="vertical"
      form={form}
      onValuesChange={() => {
        setDisabled(false);
      }}
      onFinish={handleSave}
      onFinishFailed={() => setDisabled(true)}
    >
      <div className={classes.company_panel}>
        <div className={classes.company_title}>Company info</div>
        <CompanyInfo />

      </div>
      <div className={classes.company_panel}>
        <div className={classes.company_title}>Primary account contact</div>
        <AccountContact />
      </div>
      <div className={classes.company_panel}>
        <div className={classes.company_title}>Company address</div>
        <CompanyAddress countryData={settingsInfo.country} stateData={settingsInfo.state} />
      </div>
      <div className={classes.company_panel}>
        <div className={classes.company_title}>Billing address</div>
        <BillAddress countryData={settingsInfo.billingAddress?.country} stateData={settingsInfo.billingAddress?.state} />
      </div>
      <Form.Item
        shouldUpdate
      >
        <Button
          type="primary"
          htmlType="submit"
          // onClick={handleSave}
          loading={loading}
          disabled={disabled}
        >
          Save
        </Button>

      </Form.Item>
    </Form>
  );
}
